const PinterestIcon = () => {
  return <img style={{ height: '25px' }} alt="" src="/images/pinterest.svg" />;
};

PinterestIcon.displayName = 'PinterestIcon';

export default PinterestIcon;
